import { Automation } from "../api/automation";

const first = <T, R>(
  arr: T[],
  fn: (item: T) => R | undefined
): R | undefined => {
  for (const item of arr) {
    const result = fn(item);
    if (result !== undefined) {
      return result;
    }
  }
  return undefined;
};

const getStartTime = (automation: Automation) => {
  return (
    first(automation.data.conditions, (condition) => {
      if (condition.type === "time") {
        return condition.start;
      }
    }) ?? "00:00" // Default start time if not found
  );
};

export const groupAndOrderAutomations = (automations: Automation[]) => {
  const grouped = new Map<number, Automation[]>();

  for (const automation of automations) {
    if (!grouped.has(automation.field_id)) {
      grouped.set(automation.field_id, []);
    }
    grouped.get(automation.field_id)!.push(automation);
  }

  return Array.from(grouped.entries())
    .sort(([fieldIdA], [fieldIdB]) => fieldIdA - fieldIdB)
    .map(([field_id, group]) => ({
      field_id,
      automations: group.sort((a, b) => {
        if (a.data.disabled && !b.data.disabled) {
          return 1;
        }
        if (!a.data.disabled && b.data.disabled) {
          return -1;
        }
        const startTimeA = getStartTime(a);
        const startTimeB = getStartTime(b);
        if (startTimeA < startTimeB) {
          return -1;
        }
        if (startTimeA > startTimeB) {
          return 1;
        }
        return 0;
      }),
    }));
};
